import { hash } from '@/utils/hash'
import { allAxiosInstance } from '@/service/fetch/axiosInstance'
import { API_KEY, API_CHANNEL, GET_TOEKN, SESSION_ID } from '@/config'

export function fetch (url, option = {}, name = 'base') {
  const timestamp = new Date().getTime()
  const headers = {
    requestTime: timestamp,
    sign: hash(`${timestamp}${API_KEY}`),
    token: GET_TOEKN(),
    dispatcherToken: GET_TOEKN(),
    channel: API_CHANNEL,
    sessionId: SESSION_ID
  }
  option.headers = Object.assign(headers, option.headers)
  option.url = url
  return allAxiosInstance[name].request(option).then(res => res)
}
